import { render, staticRenderFns } from "./AkreditorProfil.vue?vue&type=template&id=7b603628&"
import script from "./AkreditorProfil.vue?vue&type=script&lang=js&"
export * from "./AkreditorProfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports